import { Enum } from "./enum.class";
import EnumItem from "./enumItem.class";

/**
 * Enum de tipos de usuário
 * Representa os tipos de usuário disponíveis no sistema
 */
class TipoUsuarioEnum extends Enum {
    constructor() {
        super();
        this.OPERADOR = new EnumItem(1, 'OPERADOR');
        this.CLIENTE = new EnumItem(2, 'CLIENTE');
    }
}

export const tipoUsuarioEnum = new TipoUsuarioEnum();
